
import { Variants } from '@ds/components/Picker'

import { PICKERS_MODALS, PICKER_GROUP_WITH_THEME } from './Pickers.constants'
import PickerGroup from './components/PickerGroup'

export default {
  components: {
    PickerGroup,
  },
  props: {
    pickers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    shouldDisplayPickers() {
      return this.pickers.length > 0
    },
    variantForSelectedPickers() {
      // When a "recommended variants" picker is selected, it's theme is applied to all selected pickers.
      // Let's find out right here which color variant will be applied then!
      const pickerGroup =
        this.pickers.find(({ id }) => id === PICKER_GROUP_WITH_THEME)?.items ??
        []
      const selectedPicker = pickerGroup.find(({ selected }) => !!selected)

      return selectedPicker?.emphasis ?? Variants.Default
    },
  },
  methods: {
    hasModal(id) {
      return Boolean(PICKERS_MODALS[id])
    },
    getModal(id) {
      return PICKERS_MODALS[id]
    },
  },
}
